import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import moment from 'moment'
import merge from 'deepmerge'

const module = 'statsdisplayprints'
let doc = {
  list: {
    name: 'Impressions par type',
    headers: [
      { label: 'Nom', value: 'name' },
      { label: 'Date', value: 'dateItem', orig: 'date' },
      { label: 'Surface (m²)', value: 'countItem' },
    ],
    actions: [
    ],
    search: [
      { label: 'Du', type: 'date', name: 'from', classes: 'md6' },
      { label: 'Au', type: 'date', name: 'to', classes: 'md6' },
    ],
  },

  form: {},

  postprocess: item => {
    let dateItem = moment(item.date).format('DD/MM/YYYY')
    let countItem = parseInt(item.value)
    return {
      ...item,
      dateItem,
      countItem,
    }
  },

  params: {
    fetchAll: {},
    fetchOne: {},
  },
}

const base = crudmaker(module, apiClient, doc)

const custom = {
  state: {
    ui: {
      selector: 0,
      listView: 'line',
    },
  },
}
export default merge(base, custom)
